/*
 * Milotté product page customizations — Pass 3.18
 * Progress bar removed. Keeps: type label, hide blocks, kill animated-button, mouse drag.
 */
(function () {
  'use strict';

  function injectProductType() {
    if (!document.querySelector('.main_product')) return;
    var eyebrow = document.querySelector('.main-product__hero-eyebrow');
    if (!eyebrow) return;
    var rawText = (eyebrow.textContent || '').trim();
    if (!rawText) return;
    var niceText = rawText.charAt(0).toUpperCase() + rawText.slice(1).toLowerCase();
    var h1 = document.querySelector('.product__info-wrapper h1');
    if (!h1) return;
    var parent = h1.parentElement;
    if (parent.querySelector('.milotte-product-type')) return;
    var typeLabel = document.createElement('p');
    typeLabel.className = 'milotte-product-type';
    typeLabel.textContent = niceText;
    parent.insertBefore(typeLabel, h1.nextSibling);
  }

  function hideBlankBlocks() {
    ['.product_info-main', '.product-detail-stack', '.section-product-detail-stack',
     '.main-product__hero', '.main-product__hero-overlay'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
      });
    });
  }

  function killAnimatedButton() {
    document.querySelectorAll('.product-form__submit.animated-button, button.animated-button')
      .forEach(function (btn) { btn.classList.remove('animated-button'); });
  }

  // Remove any leftover progress bar elements from previous deploys
  function removeProgressBar() {
    document.querySelectorAll('.milotte-carousel-progress').forEach(function (el) {
      el.remove();
    });
    if (window.__milotteProgressInterval) {
      clearInterval(window.__milotteProgressInterval);
      window.__milotteProgressInterval = null;
    }
    if (window.__milotteProgressPoll) {
      clearInterval(window.__milotteProgressPoll);
      window.__milotteProgressPoll = null;
    }
  }

  function getProductMediaWrapper() {
    return (
      document.querySelector('.main_product .product__media-wrapper') ||
      document.querySelector('[class*="product__media-wrapper"]')
    );
  }

  function setupMouseDrag() {
    var wrapper = getProductMediaWrapper();
    if (!wrapper) return;
    var list = wrapper.querySelector('.product__media-list, .swiper-wrapper, .swiper, .slider, ul, ol') || wrapper;
    if (!list || list.dataset.dragEnabled) return;
    list.dataset.dragEnabled = '1';

    var isDown = false, startX = 0, scrollLeftStart = 0;
    list.addEventListener('mousedown', function (e) {
      isDown = true; list.classList.add('milotte-dragging');
      startX = e.pageX - list.offsetLeft;
      scrollLeftStart = list.scrollLeft;
      e.preventDefault();
    });
    list.addEventListener('mouseleave', function () { isDown = false; list.classList.remove('milotte-dragging'); });
    list.addEventListener('mouseup', function () { isDown = false; list.classList.remove('milotte-dragging'); });
    list.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      list.scrollLeft = scrollLeftStart - ((e.pageX - list.offsetLeft) - startX) * 1.5;
    });
  }

  function tryInit() {
    injectProductType();
    hideBlankBlocks();
    killAnimatedButton();
    removeProgressBar();
    setupMouseDrag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  window.addEventListener('load', function () {
    setTimeout(tryInit, 300);
    setTimeout(tryInit, 1500);
  });

  window.addEventListener('resize', setupMouseDrag);
})();
